import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

export const DataGridTableStyled = styled(DataGrid)(({ theme }) => ({
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: `${theme.palette.grey[100]} !important`,
    color: theme.palette.grey[600],
    fontSize: '1rem',
    fontWeight: 400,
  },
  '& .MuiDataGrid-columnHeader--filler': {
    backgroundColor: `${theme.palette.grey[100]} !important`,
  },
  '& .MuiDataGrid-scrollbarFiller--header': {
    backgroundColor: `${theme.palette.grey[100]} !important`,
  },
  '& .MuiDataGrid-filler': {
    backgroundColor: `${theme.palette.grey[100]} !important`,
    width: 0,
  },
  '& .MuiDataGrid-columnHeader button.MuiDataGrid-sortButton': {
    visibility: 'visible',
    opacity: '1 !important',
  },
  '& .MuiDataGrid-columnHeader[aria-sort="none"] .MuiDataGrid-sortButton .MuiSvgIcon-root': {
    color: `${theme.palette.grey[400]}`,
  },
  '& .MuiDataGrid-iconButtonContainer .MuiSvgIcon-root, & .MuiDataGrid-sortButton .MuiSvgIcon-root': {
    transition: 'color 0.2s ease',
  },
  '& .MuiDataGrid-cell': {
    color: theme.palette.grey[600],
    fontSize: '1rem',
  },
}));
